/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Status_In_ValidationInputs */

const en_po_status_in_validation = /** @type {(inputs: Po_Status_In_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In validation`)
};

/**
* | output |
* | --- |
* | "In validation" |
*
* @param {Po_Status_In_ValidationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_status_in_validation = /** @type {((inputs?: Po_Status_In_ValidationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Status_In_ValidationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_status_in_validation(inputs)
});